export type TenantConfigFixture = {
  configurables: TenantConfigResponse[]
  configurations: KeyValuePair[]
}

const esignConfigurables: TenantConfigResponse[] = [
  {
    key: 'esign_provider',
    label: 'Esign Provider',
    description: 'Indicates the esign provider to use.',
    isFeature: false,
    group: 'Esign',
    dataType: 'string',
    options: ['dropbox'],
    schema: '',
  },
  {
    key: 'esign_reminder_period_in_days',
    label: 'Esign Reminder Period',
    description: 'Represents the number of days between each esign reminder.',
    isFeature: false,
    group: 'Esign',
    dataType: 'int',
    options: [],
    schema: '',
  },
  {
    key: 'esign_reminder_limit',
    label: 'Esign Reminder Limit',
    description: 'Represents the number of times a user will be reminded about an esign.',
    isFeature: false,
    group: 'Esign',
    dataType: 'int',
    options: [],
    schema: '',
  },
  {
    key: 'esign_provider_client_id',
    label: 'Esign Provider Client Id',
    description: 'The client id for the esign provider.',
    isFeature: false,
    group: 'Esign',
    dataType: 'string',
    options: [],
    schema: '',
  },
]

const esignConfigurations: KeyValuePair[] = [
  { key: 'esign_provider', value: 'dropbox' },
  { key: 'esign_reminder_period_in_days', value: '0' },
  { key: 'esign_reminder_limit', value: '0' },
  { key: 'esign_provider_client_id', value: 'UNKNOWN' },
]

export const tenantConfigFixtures: Record<string, TenantConfigFixture> = {
  '/api/esign/v1': {
    configurables: esignConfigurables,
    configurations: [...esignConfigurations],
  },
}
